<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Bium_Intermittent fasting</h1>
        <p id="role">
          Product design<br />2020<br /><br />
          <a
            href="https://play.google.com/store/apps/details?id=com.dansik.fasting"
            target="_blank"
          >
            <img src="/images/googlestore.png" alt="appstore" />
          </a>
        </p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />비움(Bium)은 간헐적 단식을 돕는 앱 서비스이다.
          단식경과에 따라 내 몸이 언제 포도당에서 지방을 태우는지, 그리고 인슐린
          수치와 지방산 수치의 변화를 시각적으로 보여줌으로써 단식에 대한
          동기부여를 제공한다.
        </p>
        <p id="name">
          <b>Ideation:</b> Chulsu Kim, Kwangho Nam, Yuri Ahn<br />
          <b>UX Design:</b> Yuri Ahn<br />
          <b>UI/GUI Design:</b> Yuri Ahn<br />
          <b>Programming:</b> Kwangho Nam`
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/bium/01.png" />
        <img src="/images/portfolios/bium/02.png" />
        <img src="/images/portfolios/bium/03.png" />
        <img src="/images/portfolios/bium/04.png" />
        <img src="/images/portfolios/bium/05.png" />
        <img src="/images/portfolios/bium/06.png" />
        <img src="/images/portfolios/bium/07.png" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('telerehap')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('taste-of-book')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailBium",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/bium/top.png");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  margin-top: -5px;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
